// extracted by mini-css-extract-plugin
module.exports = {"buttonOutput":"BigButton_buttonOutput__wWq8o","buttonInput":"BigButton_buttonInput__3ka3I"};